import React from "react";
import {
  Edit,
  BooleanInput,
  TextInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  useNotify,
  useRefresh,
  NumberInput,
} from "react-admin";

import { Box, Grid } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import { MyEditActions } from "../__common/MyEditActions";
import { AutoCompleteIsolateCode } from "./AutoCompleteIsolateCode";

const useEditStyles = makeStyles({
  root: { alignItems: "flex-start" },

  box: {
    width: "100%",
  },
  grid: {
    width: "100%",
  },
  textInput: {
    width: "auto",
  },
});

export const IsolatesEdit = (props) => {
  const classes = useEditStyles();

  const notify = useNotify();
  const refresh = useRefresh();

  const onSuccess = () => {
    notify(`Changes saved`);
    refresh();
  };
  return (
    <Edit
      title="Edit Isolate"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<MyEditActions />}
      {...props}
      classes={classes}
    >
      <SimpleForm>
        <Box className={classes.box}>
          <Grid
            alignItems="flex-start"
            container
            spacing={2}
            className={classes.grid}
          >
            <Grid item xs={12}>
              <div className="title-subsection">ISOLATE INFORMATION</div>
            </Grid>
            <AutoCompleteIsolateCode></AutoCompleteIsolateCode>
            <Box width="100%" /> {/* empty space */}
            <Grid item xs={12} sm={6} md={3}>
              <BooleanInput source="is_isolated" />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <BooleanInput source="has_sequence" />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <BooleanInput source="has_picture" />
            </Grid>
            <Box width="100%" /> {/* empty space */}
            <Grid item xs={12} sm={6} md={9}>
              <TextInput
                fullWidth
                source="notes"
                label="Notes"
                multiline
                minRows={6}
              />
            </Grid>
          </Grid>
        </Box>

        <Box className={classes.box}>
          <Grid
            alignItems="flex-start"
            container
            spacing={2}
            className={classes.grid}
          >
            {/* Phenotypes */}
            <Grid item xs={12}>
              <div className="title-subsection">PHENOTYPE</div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextInput
                fullWidth
                source="isolates_phenotype.size"
                label="Size"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextInput
                fullWidth
                source="isolates_phenotype.shape"
                label="Shape"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextInput
                fullWidth
                source="isolates_phenotype.elevation"
                label="Elevation"
              />
            </Grid>
            <Box width="100%" /> {/* empty space */}
            <Grid item xs={12} sm={6} md={3}>
              <TextInput
                fullWidth
                source="isolates_phenotype.border"
                label="Border"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextInput
                fullWidth
                source="isolates_phenotype.surface"
                label="Surface"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextInput
                fullWidth
                source="isolates_phenotype.color"
                label="Color"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={9}>
              <TextInput
                fullWidth
                source="isolates_phenotype.observation"
                label="Observation"
                multiline
                minRows={6}
              />
            </Grid>
          </Grid>
        </Box>

        <Box className={classes.box}>
          <Grid
            alignItems="flex-start"
            container
            spacing={2}
            className={classes.grid}
          >
            {/* Storage */}
            <Grid item xs={12}>
              <div className="title-subsection">STORAGE</div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <ReferenceInput
                perPage={999999} // FIXME: This is a hack to avoid the "perPage" error
                label="Storage"
                source="isolates_storages[0].id_storage"
                reference="storages"
              >
                <SelectInput fullWidth optionText="storage" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextInput
                fullWidth
                source="isolates_storages[0].cryobox_name"
                label="Cryobox name"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <NumberInput
                source="isolates_storages[0].cryobox_size"
                label="Size"
                initialValue="81"
              />
            </Grid>
            <Box width="100%" /> {/* empty space */}
            <Grid item xs={12} sm={6} md={3}>
              <TextInput
                fullWidth
                source="isolates_storages[0].cryobox_position"
                label="Position"
              />
            </Grid>
            <Box width="100%" /> {/* empty space */}
            <Grid item xs={12} sm={6} md={9}>
              <TextInput
                fullWidth
                source="isolates_storages[0].notes"
                label="Notes"
                multiline
                minRows={6}
              />
            </Grid>
          </Grid>
        </Box>
      </SimpleForm>
    </Edit>
  );
};
